import React from "react";
import MessagingWidget from "../../Common/widgets/MessagingWidget";
import { useSearchParams } from "react-router-dom";

export default function ProjectInfo({ project, process }) {
  const { defaultCountry, defaultTZ } = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;

  const [sp, setSP] = useSearchParams();

  return (
    <div className="row">
      <div className="col">
        <table className="table table-borderless table-sm table-bg-transparent">
          <tbody>
            {process && (
              <>
                <tr>
                  <td className="text-secondary">Project</td>
                  <td>{project.Label}</td>
                </tr>
                <tr>
                  <td className="text-secondary">Description</td>
                  <td> {project.Description}</td>
                </tr>
              </>
            )}
            <tr>
              <td className="text-secondary">Created by</td>
              <td>{project.CreatedBy}</td>
            </tr>
            <tr>
              <td className="text-secondary">Reference</td>
              <td> {project.Reference}</td>
            </tr>
            <tr>
              <td className="text-secondary">Default country</td>
              <td> {project.CountryISO || `Default: ${defaultCountry}`}</td>
            </tr>
            <tr>
              <td className="text-secondary">Time zone</td>
              <td> {project.TimeZone || `Default: ${defaultTZ}`}</td>
            </tr>
            <tr>
              <td className="text-secondary">Status</td>
              <td> {project.Status}</td>
            </tr>
            {!!process && (
              <>
                <tr>
                  <td className="text-secondary me-1">Started at:</td>
                  <td>
                    {new Date(process.StartAt).toLocaleString()}
                    <button
                      type="button"
                      className="btn btn-colored ms-2"
                      onClick={() => {
                        setSP((prev) => {
                          const newParams = new URLSearchParams(prev);

                          const startAt = new Date(process.StartAt);
                          startAt.setMinutes(startAt.getMinutes() - 10);
                          newParams.set("start_at", startAt.toISOString());

                          return newParams;
                        });
                      }}
                    >
                      Filter from this time
                    </button>
                  </td>
                </tr>
                {process.IsActive ? (
                  <tr>
                    <td className="text-secondary me-1">Maximum milestone:</td>
                    <td>
                      {new Date(process.MaxMilestone.Time).toLocaleString()}
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td className="text-secondary me-1">End at:</td>
                    <td>
                      {new Date(process.EndAt.Time).toLocaleString()}
                      <button
                        type="button"
                        className="btn btn-colored ms-2"
                        onClick={() => {
                          setSP((prev) => {
                            const newParams = new URLSearchParams(prev);

                            const endAt = new Date(process.EndAt.Time);
                            endAt.setMinutes(endAt.getMinutes() + 10);
                            newParams.set("end_at", endAt.toISOString());

                            return newParams;
                          });
                        }}
                      >
                        Filter until this time
                      </button>
                    </td>
                  </tr>
                )}
                {process.StoppedBy && (
                  <tr className="me-3">
                    <td className="text-secondary me-1">Stopped by:</td>
                    <td>{process.StoppedBy}</td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="col-12 col-lg-6 col-xl-4 col-xxl-4">
        <div className="card-gradient text-white rounded-3">
          <MessagingWidget
            projectUUID={project.UUID}
            processGUID={process?.GUID ?? null}
          />
        </div>
      </div>
    </div>
  );
}
